/**
 * Created by sung on 2017-02-07.
 */
import {Component, OnInit} from '@angular/core';
import {NgModule} from '@angular/core';
import {TreeModule,TreeNode} from 'primeng/primeng';
import {Router} from "@angular/router";
import {MamAdminService} from '../../service/mam_service.component';
import { User } from '../../model/user';
import { ThirdPartyDept } from '../../model/thirdpartydept';
import { ThirdPartyCompany } from '../../model/thirdpartycompany';
import { Device } from '../../model/device';
import {Logger, Options, Level } from "angular2-logger/core"; // ADD THIS
@Component({

  selector: 'company-tree',
  templateUrl: 'company_tree.html'
})
export class CompanyTreeComponent implements OnInit {

  private dept : ThirdPartyDept[] = [];
  private deptModel : ThirdPartyDept;
  private company : ThirdPartyCompany[] = [];
  private companyModel : ThirdPartyCompany;
  private user : User[] = [];
  private device : Device[] = [];
  private treeTemp : any[] = [];

  filesTree2: TreeNode[];
  p_node: TreeNode;
  items : boolean;
  companyNode : TreeNode[] = [];
  userTreeNode : TreeNode[] = [];

  deptNode : TreeNode[] = [];

  createNode(data:any){

    for(var i = 0 ; i< data.length ; i++) {
      let type = data[i].type;

      this.logger.debug("data :", this.companyModel);
      this.logger.debug("type :", data[i].type);
      if(type == 'C') {
        this.userTreeNode = [{
          "label" : data[i].name,
          "data" :data[i].id,
          "expandedIcon" : "fa-foler-open",
          "collapsedIcon": "fa-folder",
           "children": []
        }];
      }
    }
  }

  createChlidrenNode() {
    /*this.userTreeNode[0].children.push();
    this.logger.debug("userTreeNode :" , this.userTreeNode);
    this.userTreeNode.forEach(treenode =>{
      this.logger.debug("tree Node :", treenode);
      this.dept.forEach(dModel =>{
        this.logger.debug("dModel :" , dModel);
        let t_node = this.createDeptNode(dModel);
        treenode.children.push(t_node);
      });

    })*/

  }
createDeptNode(dept : ThirdPartyDept) : TreeNode {
  this.logger.debug("dept : ", dept);
    let node : TreeNode = {
      label : dept.name,
      data: dept.id
    }
    return node;
  }

  constructor(private router: Router, private service : MamAdminService, private logger : Logger){}
  ngOnInit() {
    this.logger.debug("tree컴퍼넌트 입니다.");
    this.getUserTree(1,"5",4);
    this.getUserTree(1,"C",4);
    // this.filesTree2 = [
    //   {
    //     "label": "Documents",
    //     "data": "Documents Folder",
    //     "expandedIcon": "fa-folder-open",
    //     "collapsedIcon": "fa-folder",
    //     "children": [{
    //       "label": "Work",
    //       "data": "Work Folder",
    //       "expandedIcon": "fa-folder-open",
    //       "collapsedIcon": "fa-folder",
    //       "children": [{"label": "Expenses.doc", "icon": "fa-file-word-o", "data": "Expenses Document"}, {"label": "Resume.doc", "icon": "fa-file-word-o", "data": "Resume Document"}]
    //     },
    //       {
    //         "label": "Home",
    //         "data": "Home Folder",
    //         "expandedIcon": "fa-folder-open",
    //         "collapsedIcon": "fa-folder",
    //         "children": [{"label": "Invoices.txt", "icon": "fa-file-word-o", "data": "Invoices for this month"}]
    //       }]
    //   },
    //   {
    //     "label": "Pictures",
    //     "data": "Pictures Folder",
    //     "expandedIcon": "fa-folder-open",
    //     "collapsedIcon": "fa-folder",
    //     "children": [
    //       {"label": "barcelona.jpg", "icon": "fa-file-image-o", "data": "Barcelona Photo"},
    //       {"label": "logo.jpg", "icon": "fa-file-image-o", "data": "PrimeFaces Logo"},
    //       {"label": "primeui.png", "icon": "fa-file-image-o", "data": "PrimeUI Logo"}]
    //   },
    //   {
    //     "label": "Movies",
    //     "data": "Movies Folder",
    //     "expandedIcon": "fa-folder-open",
    //     "collapsedIcon": "fa-folder",
    //     "children": [{
    //       "label": "Al Pacino",
    //       "data": "Pacino Movies",
    //       "children": [{"label": "Scarface", "icon": "fa-file-video-o", "data": "Scarface Movie"}, {"label": "Serpico", "icon": "fa-file-video-o", "data": "Serpico Movie"}]
    //     },
    //       {
    //         "label": "Robert De Niro",
    //         "data": "De Niro Movies",
    //         "children": [{"label": "Goodfellas", "icon": "fa-file-video-o", "data": "Goodfellas Movie"}, {"label": "Untouchables", "icon": "fa-file-video-o", "data": "Untouchables Movie"}]
    //       }]
    //   }
    // ];
    //this.nodeService.getLazyFiles().then(files => this.lazyFiles = files);
  }

  nodeSelect(event){
    let link;
    this.logger.debug(event);
    //this.logger.debug(event.node.label);

    this.items = true;

    //link = ['device/deviceCondition/companyTree', "8"];
    //this.logger.debug(link);
    //this.router.navigate(link);
    //this.router.navigate(['/device/deviceCondition/companyTree', {outlets: {'right': '8'}}]);
  }

  nodeUnselect(event){
    this.logger.debug(event);
  }


  //------------------------- service -----------------------------------
  getUserTree(id:number, type:string, depth:number) {
    this.service.getUserTree(id, type, depth).subscribe(
      value => {
        if(type == 'C') {
          this.dept = value;
          this.logger.debug("$$ dept : ", value);
          this.createChlidrenNode();
          //this.createNode(this.company);

        } else if(type == 'P') {
          this.dept = value;
          this.logger.debug("$$ dept : ", value);
        } else if(type == 'U') {
          this.user = value.rows;
          this.logger.debug("$$ user : ", value);
        } else if(type == 'D') {
          this.device = value.rows;
          this.logger.debug("$$ device : ", value);
        } else {
          //this.company = value;
          this.logger.debug("type == 5")
          this.logger.debug("$$ company1 : ", value);
          this.createNode(value);
        }

      },
      error => {
        this.logger.error("-- error : " + error);
      },
      () => {
        this.logger.info("-- complate : ");
      }
    )
  }
}

@NgModule({
  imports: [TreeModule,],
  exports: [CompanyTreeComponent],
  declarations: [CompanyTreeComponent],
  providers: [MamAdminService],
})
export class CompanyTreeModule {
}



// WEBPACK FOOTER //
// ./src/app/page/device/company_tree.ts